import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nav-dropdown"
export default class extends Controller {

  toggle(e) {    
    let menus = document.querySelectorAll('.header-nav-list__item.open')
    menus.forEach(menu => {
      if(menu != this.element){
        menu.classList.remove('open');
      }
    });
    
    this.element.classList.toggle('open');
  }

}
